/**
 * @代理相关接口
 * 2025-09-28 kadiam 首次开发 （涛）
 * 2025-11-11 kadiam 增加我的代理 续期功能 （胡）
*/
import bossWholesale from '../utils/wholesaleRequest'

// 2025-09-28
// 代理品牌列表
export function apiWholesaleAgent_list(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleAgent/list', method: 'post', data })
}
// 代理品牌简介
export function apiWholesaleAgent_intro(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleAgent/intro?wholesaleAgentBrandId=' + data, method: 'get' })
}
// 代理品牌单个明细
export function apiWholesaleAgent_cartList(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleAgentCart/cartList?wholesaleAgentBrandId=' + data, method: 'get' })
}
// 代理统计
export function apiWholesaleAgent_cartStatistics(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleAgentCart/cartStatistics', method: 'get' })
}
// 省份显示
export function apiWholesaleAgent_provinceSelection(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleAgentCart/provinceSelection?wholesaleAgentBrandId=' + data, method: 'get' })
}
// 城市显示
export function apiWholesaleAgent_citySelection(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleAgentCart/citySelection', method: 'post', data })
}
// 添加城市
export function apiWholesaleAgent_addCity(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleAgentCart/addCity', method: 'post', data })
}
// 删除城市
export function apiWholesaleAgent_removeCity(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleAgentCart/removeCity', method: 'post', data })
}
// 商品查询
export function apiWholesaleAgent_productSelection(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleAgentCart/productSelection', method: 'post', data })
}
// 修改商品 购买数量=0时,执行删除逻辑
export function apiWholesaleAgent_updateProduct(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleAgentCart/updateProduct', method: 'post', data })
}
// 被代理-取消代理设置的城市查询,确认订单-提交订单之前使用
export function apiWholesaleAgent_agentStatusTwoList(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleAgentCart/agentStatusTwoList', method: 'get' })
}
// 清空被代理城市
export function apiWholesaleAgent_clearAgentStatusTwo(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleAgentCart/clearAgentStatusTwo', method: 'get' })
}
// 2025-11-11
// 我的品牌列表
export function apiWholesaleAgentRebuy_brandList(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleAgentRebuy/brandList', method: 'post', data })
}
// 城市列表
export function apiWholesaleAgentRebuy_cityList(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleAgentRebuy/cityList', method: 'post', data })
}
// 默认添加最近一次代理的城市
export function apiWholesaleAgentRebuy_addDefaultCity(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleAgentRebuy/addDefaultCity', method: 'post', data })
}
// 添加城市 删除城市 type add del
export function apiWholesaleAgentRebuy_changeCity(data, type) {
  return bossWholesale({
    url: type === 'add' ? 'wholesale/api/apiWholesaleAgentRebuy/addCity' : 'wholesale/api/apiWholesaleAgentRebuy/removeCity',
    method: 'post', data
  })
}
// 代理统计
export function apiWholesaleAgentRebuy_cartStatistics(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleAgentRebuy/cartStatistics?wholesaleAgentBrandId=' + data, method: 'get' })
}
// 商品列表
export function apiWholesaleAgentRebuy_productList(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleAgentRebuy/productList', method: 'post', data })
}
// 修改商品 购买数量=0时,执行删除逻辑
export function apiWholesaleAgentRebuy_updateProduct(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleAgentRebuy/updateProduct', method: 'post', data })
}
